export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Puzzles
    {
      title: 'Jogos',
      name: 'puzzles',
      to: {
        name: 'admin-puzzle-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">extension</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-puzzle-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-puzzle-new',
          },
        },
      ],
    },
    // Magazines
    {
      title: 'Revistas',
      name: 'magazines',
      to: {
        name: 'admin-magazine-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">menu_book</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-magazine-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-magazine-new',
          },
        },
      ],
    },
    // Banner
    {
      title: 'Banner',
      name: 'banners',
      to: {
        name: 'admin-banner-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">view_array</i>',
    },
    // Comments
    {
      title: 'Comentários',
      name: 'comments',
      to: {
        name: 'admin-comment-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">announcement</i>',
    },
    // User
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
